export default {
  main: '#83B19A',
  secondary: '#313131',
  contrastingColor: '#ffffff',
  priceColor: '#313131',
  entryBackground: '#83B19A',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
